<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">CROP IMMAGINE</div>
</div>

<!-- Modal body -->
<div class="modal-body">

    <div class="row">
        <div class="text-center col-md-6">
            <h5>Immagine principale</h5>
            <div class="box-imagecropper">
                <image-cropper 
                    #cropperImage
                    *ngIf="imageBlob"
                    [imageFile] = "imageBlob"
                    [imageChangedEvent]="imageChangedEvent" 
                    [maintainAspectRatio]="false" 
                    [containWithinAspectRatio]="false"
                    [aspectRatio]="1 / 1"
                    [resizeToWidth]="500"
                    [resizeToHeight]="500"
                    [imageQuality]="100"
                    format="{{imageFormat}}" 
                    (imageCropped)="imageCropped($event)" 
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady()" 
                    (loadImageFailed)="loadImageFailed()">
                </image-cropper>
                <img    *ngIf="!imageBlob"
                        alt=""
                        class="load-image"
                        src="/assets/images/spinner/iphone-spinner-1.gif">
            </div>
        </div>
        <div class="text-center col-md-6">
            <h5>Anteprima crop</h5>
            <div class="box-imagecropper">
                <img    *ngIf="imageBlob"
                        alt=""
                        [src]="croppedImage" />
                <img    *ngIf="!imageBlob"
                        alt=""
                        class="load-image"
                        src="/assets/images/spinner/iphone-spinner-1.gif">
            </div>
        </div>
    </div>
    
   


    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">

            <button type="submit" class="btn btn-fw text me-3" (click)="clickButtonSave()"
            [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false"
            >Salva modifiche</button>
            <button type="button" class="btn btn-outline-fw text"
                (click)="clickButtonCancel()">Annulla</button>

        </div>
    </div>
</div>